import { AcceptMail } from "./AcceptMail";
export default AcceptMail